export * from './report-detail.component';
export * from './report-detail.module';
